import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { NavItem } from './nav-item';
import { Router } from '@angular/router';
import { NavService } from '../../../../services/nav.service';
import { LoggingService } from 'src/app/services/consoleLogs';

@Component({
  selector: 'app-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrl: 'nav-item.component.scss'
})
export class AppNavItemComponent implements OnChanges, OnInit {
  @Input() item: NavItem | any;
  @Input() depth: any;
  @Input() activeRoute?: string;
  @Input() isCollapsed: boolean = false;
  @Output() itemSelected = new EventEmitter<NavItem>();
  @Output() parentIconClick = new EventEmitter<NavItem>();

  constructor(
    public navService: NavService, 
    public router: Router,
    private loggingService: LoggingService 
  ) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  ngOnInit() {
    this.checkActiveRoute();
    if (this.isItemActive(this.item)) {
      this.loggingService.log(`Active tab on load: ${this.item.displayName || this.item.navCap}`);
    }
  }

  hasActiveChild(): boolean {
    if (!this.item.children) return false;
    
    const currentUrl = this.router.url;
    return this.item.children.some((child: NavItem) => 
      child.route && currentUrl.includes(child.route)
    );
  }

  ngOnChanges() {
    this.checkActiveRoute();
  }

  isItemActive(item: NavItem): boolean {
    if (!item) return false;

    const currentUrl = this.router.url.split('?')[0];

    if (item.route) {
      const baseMatch = this.router.isActive(item.route, {
        paths: 'subset',
        queryParams: 'subset',
        fragment: 'ignored',
        matrixParams: 'ignored'
      });
      if (baseMatch) return true;
    }

    if (item.relatedRoutes) {
      const relatedMatch = item.relatedRoutes.some((relatedRoute: string) => {
        const baseRelatedRoute = relatedRoute.split('?')[0];
        return currentUrl.startsWith(baseRelatedRoute);
      });
      if (relatedMatch) return true;
    }

    return false;
  }

  checkActiveRoute() {
    // Just for checking active state, no expand/collapse logic
  }

  onItemSelected(item: NavItem) {
    if (!item.children || !item.children.length) {
      this.router.navigate([item.route]);
    }
    this.itemSelected.emit(item);

    document.querySelector('.page-wrapper')?.scroll({
      top: 0,
      left: 0,
    });
  }

  onParentIconClick(item: NavItem) {
    this.parentIconClick.emit(item);
    
    if (item.children && item.children.length > 0) {
      const firstChild = item.children[0];
      if (firstChild.route) {
        this.router.navigate([firstChild.route]);
      }
    }
  }
}